import React, { useEffect, useState } from 'react';
import '../styles/phcolours.css';
import useUIPresentationMode from '../helpers/useUIPresentationMode';

const topButtonStyle = {
  padding: '9px 14px',
  fontSize: '16px',
  fontWeight: '600',
  border: 'none',
  borderRadius: '999px',
  cursor: 'pointer',
  background: 'var(--phblueaccentwashedwithtransparency)',
  color: 'var(--phblue)',
  transition: 'all 0.2s ease-in-out',
};

export default function UITopButtonsUsage({ onZoomToNZ, pinCount = 0 }) {
  const { presentationModeSize } = useUIPresentationMode();
  const isVeryNarrowScreen = presentationModeSize >= 4;
  const [scaleFactor, setScaleFactor] = useState(0.9);

  useEffect(() => {
    if (presentationModeSize === 1 || presentationModeSize === 2) setScaleFactor(1);
    if (presentationModeSize === 3) setScaleFactor(0.9);
    if (presentationModeSize === 4 || presentationModeSize === 5) setScaleFactor(0.9);
  }, [presentationModeSize]);

  return (
    <div
      className="ui-top-buttons"
      style={{
        position: 'absolute',
        width: '90%',
        maxWidth: '760px',
        top: '15px',
        left: '50%',
        transform: `translate(-50%) scale(${scaleFactor})`,
        display: 'flex',
        alignItems: 'center',
        gap: isVeryNarrowScreen ? '13px' : '20px',
        zIndex: 1000,
        backgroundColor: 'transparent',
        whiteSpace: 'nowrap',
        flexWrap: 'wrap',
        justifyContent: 'center',
        padding: '7px 35px',
      }}
    >
      <button
        onClick={onZoomToNZ}
        style={{
          ...topButtonStyle,
          boxShadow: 'var(--ph-box-shadow-nothover)',
        }}
        onMouseEnter={(e) => { e.currentTarget.style.boxShadow = 'var(--ph-box-shadow-hover)'; }}
        onMouseLeave={(e) => { e.currentTarget.style.boxShadow = 'var(--ph-box-shadow-nothover)'; }}
      >
        Zoom to NZ{' '}
        <span style={{ fontWeight: 400, opacity: 0.7 }}>
          ({pinCount})
        </span>
      </button>
    </div>
  );
}
